// actions
export const SEASON_FOR_EDIT = 'SEASON_FOR_EDIT';
export const OFFER_FOR_EDIT = 'OFFER_FOR_EDIT';
// mutations
export const SET_SEASON = 'SET_SEASON';
export const SET_OFFER = 'SET_OFFER';
